import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';

const empty = { username: '', password: '', role: 'member', approved: true, player_id: '' };
export default function AdminAccounts() {
  const { user, request } = useAuth();
  const [users, setUsers] = useState([]);
  const [players, setPlayers] = useState([]);
  const [form, setForm] = useState(empty);
  const [editing, setEditing] = useState(null);
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const [busy, setBusy] = useState(false);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    Promise.all([request('get', '/account/admin/users'), request('get', '/account/admin/players')])
      .then(([accounts, profiles]) => { setUsers(accounts); setPlayers(profiles); })
      .catch(err => setError(err.message)).finally(() => setLoading(false));
  }, [request]);
  const field = (name, value) => setForm({ ...form, [name]: value });
  async function save(event) {
    event.preventDefault(); setBusy(true); setError(''); setMessage('');
    try {
      const body = { ...form, player_id: form.player_id ? Number(form.player_id) : null };
      await request(editing ? 'patch' : 'post', editing ? `/account/admin/users/${editing}` : '/account/admin/users', body);
      setMessage(editing ? 'Account updated. Previous sessions have been revoked.' : 'Account created. Share the credentials privately with the user.');
      setEditing(null); setForm(empty);
      setUsers(await request('get', '/account/admin/users'));
    } catch (err) { setError(err.message); }
    finally { setBusy(false); }
  }
  async function resetPassword() {
    setBusy(true); setError(''); setMessage('');
    try {
      await request('post', `/account/admin/users/${editing}/password`, { password: form.password });
      setForm({ ...form, password: '' }); setMessage('Password reset. Previous sessions have been revoked.');
    } catch (err) { setError(err.message); }
    finally { setBusy(false); }
  }
  return <main className="account-page">
    <h1>Admin tools</h1><p><Link to="/CreatePlayer">Manage player profiles</Link></p>
    {error && <p role="alert">{error}</p>}{message && <p role="status">{message}</p>}
    {loading && <p role="status">Loading accounts…</p>}
    <section><h2>{editing ? `Edit ${form.username}` : 'Create an account'}</h2>
      <form className="account-form" onSubmit={save}>
        {!editing && <label>Username<input autoComplete="off" required minLength={3} maxLength={64} pattern="[A-Za-z0-9_.\-]+" value={form.username} onChange={e => field('username', e.target.value)} /></label>}
        <label>{editing ? 'New password (only for password reset)' : 'Password (15–128 characters)'}<input type="password" autoComplete="new-password" required={!editing} minLength={15} maxLength={128} value={form.password} onChange={e => field('password', e.target.value)} /></label>
        <label>Role<select value={form.role} onChange={e => field('role', e.target.value)}><option value="member">Member</option><option value="admin">Administrator</option></select></label>
        <label>Linked player profile<select value={form.player_id || ''} onChange={e => field('player_id', e.target.value)}><option value="">No linked profile</option>{players.map(p => <option key={p.id} value={p.id}>{p.player_name} (#{p.id})</option>)}</select></label>
        <label><input type="checkbox" checked={form.approved} onChange={e => field('approved', e.target.checked)} />Approved to log in</label>
        <div className="account-actions"><button disabled={busy || loading}>{editing ? 'Save account' : 'Create account'}</button>
          {editing && <><button type="button" disabled={busy || form.password.length < 15} onClick={resetPassword}>Reset password</button><button type="button" disabled={busy} onClick={() => { setEditing(null); setForm(empty); }}>Cancel</button></>}
        </div>
      </form>
    </section>
    <section><h2>Accounts</h2><div className="account-table-wrap"><table className="account-table"><thead><tr><th>Username</th><th>Role</th><th>Access</th><th>Player</th><th>Action</th></tr></thead><tbody>
      {users.map(account => <tr key={account.id}><td>{account.username}</td><td>{account.role}</td><td>{account.approved ? 'Approved' : 'Disabled'}</td><td>{(players.find(p => p.id === account.player_id) || {}).player_name || 'Not linked'}</td><td>{account.id === user.id ? 'Your account' : <button disabled={busy} onClick={() => { setEditing(account.id); setForm({ ...account, password: '' }); setMessage(''); }}>Edit</button>}</td></tr>)}
    </tbody></table></div></section>
  </main>;
}
